import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useContext } from 'react';

import { AiAssessedScore } from '../frontendServices/gameAPI';
import { SocketContext } from '../providers/SocketProvider/SocketProvider';

const useAiAssessedScore = (
  gameId: string,
  slideId: string,
  tenantId: string,
  responseIds: string[],
) => {
  const { gameAPI } = useContext(SocketContext);
  const client = useQueryClient();
  const scoresCacheKey = ['aiAssessedScores', gameId, slideId];
  const {
    mutate: updateAiAssessedSingleScore,
    data: newAiAssessedScore,
    isLoading: isFetchingSingle,
  } = useMutation(
    scoresCacheKey,
    async () => {
      if (!gameAPI) return Promise.resolve(undefined);
      return gameAPI.game.aiAssessSingle({
        gameId,
        slideId,
        tenantId,
        responseIds,
      });
    },
    {
      onSuccess: newAiAssessedScore => {
        client.setQueryData<AiAssessedScore[] | undefined>(
          scoresCacheKey,
          previousScores => {
            if (!previousScores || !newAiAssessedScore) return previousScores;
            const updatedAiScores = previousScores.map(oldScore => {
              const newScore = newAiAssessedScore.results.find(
                r => r.responseId === oldScore.responseId,
              );

              return newScore || oldScore;
            });
            return updatedAiScores;
          },
        );
      },
      retry: 3,
      retryDelay: 400,
    },
  );

  return {
    updateAiAssessedSingleScore,
    aiAssessedScoreSingle: newAiAssessedScore?.results[0],
    isFetchingSingle,
  };
};

export default useAiAssessedScore;
